import styled from "styled-components";
import { IconButton } from "@material-ui/core";

export const StyledCloseButton = styled(IconButton)`
  &&{
    position: absolute;
    right: 10px;
    top: 10px;
  }
`;